import { ACTION } from '@cvent/react-analytics';

export const applyAttendanceTypeFilter = {
  id: 'event_calendar_apply_attendance_type_filter',
  name: 'Apply attendance type filter to upcoming events list',
  type: ACTION,
  destinations: ['Mixpanel', 'Analytics'],
  attributes: ['filterType', 'filterValues'],
  objectIdAttribute: 'attendeeId',
  activityType: 'attendee.filter_applied'
};

export const openCalendarLink = {
  id: 'open_calendar_link',
  name: 'Open Calendar Link',
  type: ACTION,
  destinations: ['Mixpanel', 'Analytics'],
  attributes: ['calendarLinkDestination', 'calendarLinkURL'],
  objectIdAttribute: 'attendeeId'
};

export const openAttendeeHub = {
  id: 'event_app_open_attendee_hub_from_calendar',
  name: 'Opened new event from Upcoming Events',
  type: ACTION,
  destinations: ['Mixpanel', 'Analytics'],
  attributes: ['redirectLoginURL'],
  objectIdAttribute: 'attendeeId'
};

export const loginAttendeeHub = {
  id: 'event_app_login_attendee_hub_from_calendar',
  name: 'Logged into new Attendee Hub from Upcoming Events',
  type: ACTION,
  destinations: ['Mixpanel', 'Analytics'],
  attributes: ['loggedInEventName', 'redirectLoginURL'],
  objectIdAttribute: 'attendeeId'
};
